import React from 'react';

import { LegacyText } from '@gogame/components';

import BudgetGrid from 'scenes/MarketingPlanning/MarketingPlanningWizard/MarketingPlanningPreview/components/BudgetGrid';
import NodesBudget from 'scenes/MarketingPlanning/MarketingPlanningWizard/MarketingPlanningPreview/components/NodesBudget';
import { ValidationErrors } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/Validation';
import { NETWORKS } from 'scenes/MarketingPlanning/MarketingPlanningWizard/constants';

import { Header } from './components';

const TotalLevel = () => {
  return (
    <React.Fragment>
      <Header gutter={8} align={'center'}>
        <LegacyText variant={'h6'}>Total Budget</LegacyText>
      </Header>
      <BudgetGrid withBudgetPercent={false} withMetricApplyBelow={false} />
      <ValidationErrors />
      <NodesBudget levelName={NETWORKS} />
    </React.Fragment>
  );
};

export default TotalLevel;
